import React, { lazy, useCallback, useState } from 'react';
import { IdentificationModalWrapper } from '@fiverr-private/identification_core';
import { IdentificationFormProps } from '../../components/IdentificationForm/IdentificationForm.types';
import { StepId } from '../../constants/stepId';

const LazyIdentificationForm = lazy(
    () => import(/* webpackChunkName: "LazyIdentificationBusinessForm" */ '../../components/IdentificationForm')
);

interface IdentificationModalProps {
    googleClientId: string;
    inBeetlesMigrateSignupWebRollout: boolean;
    inBeetlesMigrateSigninWebRollout: boolean;
    inBeetlesMigrateSocialSignUpRollout: boolean;
}

const CLOSABLE_STEPS: StepId[] = ['initial', 'email_identification', 'profile_setup'];

export const IdentificationModal: React.FC<IdentificationModalProps> = ({
    googleClientId,
    inBeetlesMigrateSignupWebRollout,
    inBeetlesMigrateSigninWebRollout,
    inBeetlesMigrateSocialSignUpRollout,
}) => {
    const [closeOnOverlayClick, setCloseOnOverlayClick] = useState(true);

    const onStepIdChange: IdentificationFormProps['onStepIdChange'] = useCallback(
        (stepId) => {
            if (stepId === 'code_activation') {
                setCloseOnOverlayClick(false);

                return;
            }

            setCloseOnOverlayClick(CLOSABLE_STEPS.includes(stepId));
        },
        [setCloseOnOverlayClick]
    );

    return (
        <IdentificationModalWrapper
            googleClientId={googleClientId}
            closeOnOverlayClick={closeOnOverlayClick}
            renderLazyComponent={({
                isModal,
                isModalOpen,
                closeModal,
                mode,
                redirectUrl,
                email,
                username,
                isSticky,
                blockedActionType,
                bigQueryEnrichment,
                mixpanelEnrichment,
                afterSigningSuccess,
                isSocialFlow,
                stepId,
                skipActivation,
                isCodeActivationSkippable,
                source,
            }) => (
                <LazyIdentificationForm
                    {...{
                        isModal,
                        isModalOpen,
                        closeModal,
                        mode,
                        redirectUrl,
                        email,
                        username,
                        isSticky,
                        blockedActionType,
                        bigQueryEnrichment,
                        mixpanelEnrichment,
                        afterSigningSuccess,
                        isSocialFlow,
                        stepId,
                        skipActivation,
                        isCodeActivationSkippable,
                        source,
                    }}
                    onStepIdChange={onStepIdChange}
                    inBeetlesMigrateSignupWebRollout={inBeetlesMigrateSignupWebRollout}
                    inBeetlesMigrateSigninWebRollout={inBeetlesMigrateSigninWebRollout}
                    inBeetlesMigrateSocialSignUpRollout={inBeetlesMigrateSocialSignUpRollout}
                />
            )}
        />
    );
};
